import React, { PureComponent } from 'react' // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'
import Measure from 'react-measure'
import ScrollPercentage from 'react-scroll-percentage'
import throttle from 'lodash/throttle'

const THROTTLE_INTERVAL = 100

class VisibleObserver extends PureComponent {
  state = {
    inView: false,
    bounds: {}
  }

  handleChange = throttle((measure) => ({ inView }) => {
    measure()
    this.setState({ inView })
  }, THROTTLE_INTERVAL, { trailing: true, leading: true })

  handleResize = throttle((contentRect) => {
    this.setState(contentRect)
  }, THROTTLE_INTERVAL, { trailing: true, leading: true })

  render() {
    const { children, threshold, ...props } = this.props

    return (
      <Measure bounds client offset scroll onResize={this.handleResize}>
        {({ measureRef, contentRect, measure }) =>
          <ScrollPercentage onChange={this.handleChange(measure)}>
            <div ref={measureRef}>
              { children(this.state) }
            </div>
          </ScrollPercentage>
        }
      </Measure>
    )
  }
}

export default VisibleObserver



// WEBPACK FOOTER //
// ./src/components/utility/VisibleObserver.js